import { Star, BadgeCheck } from "lucide-react";

const reviews = [
  {
    id: "review-appstore-1",
    title: "Awesome App!",
    comment: null,
  },
  {
    id: "review-appstore-2",
    title: null,
    comment:
      "This app has it all. It keep track of bills and their due date. It also keeps track of your income. Very easy to navigate. And it lets you know when and How much extra money you have.",
  },
];

const Stars = () => (
  <span className="flex gap-0.5 text-amber-400">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="h-4 w-4 fill-amber-400" />
    ))}
  </span>
);

export const SocialProofSection = () => (
  <section
    id="reviews"
    data-testid="social-proof-section"
    className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8"
  >
    <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <p className="font-mono-num text-xs font-semibold uppercase tracking-[0.2em] text-sky-400">
          Community validation
        </p>
        <div
          data-testid="social-proof-rating-badge"
          className="mt-6 inline-flex flex-col gap-3 rounded-2xl border border-amber-400/25 bg-amber-400/5 p-8"
        >
          <span className="font-mono-num text-6xl font-semibold text-white">5.0</span>
          <span className="flex gap-1 text-amber-400">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-6 w-6 fill-amber-400" />
            ))}
          </span>
          <span className="text-sm text-slate-300">
            Rated 5.0 stars by early iOS adopters
          </span>
        </div>
        <h2 className="mt-8 text-2xl font-bold tracking-tight text-white sm:text-3xl">
          Loved by people who get paid irregularly
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
        {reviews.map((r) => (
          <figure
            key={r.id}
            data-testid={r.id}
            className="flex flex-col rounded-2xl border border-white/10 bg-[#0D1527]/90 p-7 transition-[border-color] duration-300 hover:border-sky-400/30"
          >
            <Stars />
            <blockquote className="mt-4 flex-1">
              {r.title && (
                <p className="text-base font-semibold text-white">{r.title}</p>
              )}
              {r.comment && (
                <p className="mt-2 text-sm leading-relaxed text-slate-300">
                  “{r.comment}”
                </p>
              )}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-1.5 text-[11px] text-slate-500">
              <BadgeCheck className="h-3.5 w-3.5 text-sky-400" />
              Verified App Store Review
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
